import { useTranslation } from "react-i18next";

/** Neutral "link not available" frame; the page background stays transparent. */
export default function UnavailableFrame() {
  const { t } = useTranslation("broadcast");
  return (
    <div
      data-testid="broadcast-unavailable"
      style={{
        position: "fixed",
        inset: 0,
        background: "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "rgba(8,15,30,0.85)",
          color: "#e2e8f0",
          padding: "0.9rem 1.4rem",
          borderRadius: "0.6rem",
          fontFamily: "system-ui, sans-serif",
          fontSize: "1.1rem",
        }}
      >
        {t("unavailable")}
      </div>
    </div>
  );
}
